import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ServiceGroup} from "../../models/service-group";
import Helpers from "../../utils/helpers";

@Injectable()
export class ServiceGroupControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public createGroup(serviceGroup: ServiceGroup): Observable<ServiceGroup> {
    Helpers.trimRecursiveObj(serviceGroup);
    const body = JSON.stringify(serviceGroup);
    return this.http.post(this.baseUrl + "service_group", body) as  Observable<ServiceGroup>;
  }

  public deleteGroup(serviceGroupId: string) {
    return this.http.delete(this.baseUrl + "service_group/" + serviceGroupId, {responseType: "text"});
  }

  public updateGroup(serviceGroup: ServiceGroup) {
    const body = JSON.stringify(serviceGroup);
    return this.http.put(this.baseUrl + "service_group", body, {responseType: "text"});
  }

  public getAllServiceGroups(): Observable<ServiceGroup[]> {
    return this.http.get(this.baseUrl + "service_group") as  Observable<ServiceGroup[]>;
  }

  public getGroupServices(erviceGroupId: string): Observable<ServiceGroup> {
    return this.http.get(this.baseUrl + "service_group/" + erviceGroupId + "/services") as  Observable<ServiceGroup>;
  }

}
